<script>
export default {
  name: "AppFeatureTabs",
  props:{
    title:{
      type:Array,
      required: true
    }
  },
  data(){
    return{
      current: 0
    }
  },
  methods:{
    handleClick(i){
      this.current  = i
      this.$emit('tab-change', i)
    }
  },
  computed:{
    tabTitles(){
      return this.title
    },
    sliderStyle(){
      return {
        transform: `translateX(${this.current * 100}%)`
      };
    }
  }
}
</script>

<template>
<div class="tab-container">
  <div class="tabs-header">
    <div class="tab-label" v-for="(tab, index) in tabTitles" :key="index" :class="{ active : current === index}" @click="handleClick(index)">
      <img class="icon vertical-middle" :src="tab.icon" alt="icon">
      <span class="title">{{tab.title}}</span>
    </div>
    <div class="d-xs-block d-lg-none">
      <div class="slider" :style="sliderStyle"/>
    </div>
  </div>
  <div class="tabs-body">
    <slot></slot>
  </div>
</div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.tab-container{
  padding: 70px 281px 0;
  width: 100%;
  .tabs-header{
    display: flex;
    flex-direction: row;
    position: relative;
    .tab-label{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      background: #fff2bc;
      border-radius: 26px 26px 0 0;
      padding: 25px 0;
      cursor: pointer;
      user-select: none;
      .icon{
        width: 50px;
        height: 50px;
        object-fit: contain;
        margin-bottom: 10px;
        filter: grayscale(100%);
        transition: filter .3s ease;
      }
      .title{
        text-align: center;
        color: #666666;
        font-size: 23px;
        font-weight: bold;
        transition: color .3s ease;
      }
    }
    .active{
      background: #ffffff;
      .icon{
        filter: grayscale(0);
      }
      .title{
        color: #158800;
      }
    }
    .slider{
      position: absolute;
      bottom: 10%;
      left: 0;
      //根据tab的数量多少改宽度
      width: 25%;
      display: flex;
      justify-content: center;
      height: 4px;
      transition: transform 0.3s ease;
      &:after {
        content: '';
        display: block;
        width: 30px;
        height: 4px;
        background-color: #158800;
        border-radius: 2px;
      }
    }
  }
  .tabs-body{
    background: #FFFFFF;
    padding: 70px 60px;
    border-radius: 0 0 26px 26px;
    >div{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .tabs-title{
        color: #5A2A00;
        font-size: 30px !important;
        line-height: 32px !important;
      }
      .tabs-content{
        margin-top: 40px;
        display: flex;
        column-gap: 70px;
        width: 85%;
        align-items: center;
      }
    }

  }
  @media (max-width: 1700px) {
    padding: 70px 130px 0;
  }
  @include media-max(xxl) {
    padding: 70px 100px 0;
    .tabs-header{
      .tab-label{
        .title{
          font-size: 19px;
        }
      }
    }
    .tabs-body{
      >div{
        .tabs-title{
          font-size: 25px !important;
        }
      }

    }
  }
  @include media-max(lg){
    .tabs-header{
      flex-direction: column;
      .tab-label{
        border-radius: 0;
        flex-direction:row;
        justify-content: flex-start;
        padding: 15px 0 15px 30px;
        column-gap: 15px;
        border-left: 4px solid transparent;
        .icon{
          margin-bottom: 0;
        }
      }
      .active{
        border-left: 4px solid #158800;
      }
    }
    .tabs-body{
      >div{
        .tabs-title{
          margin-top: 34px;
          margin-bottom: 12px;
        }
        .tabs-content{
          margin-top: 0;
          width: 100%;
          flex-direction: column;
          p{
            padding: 0 !important;
          }
        }
      }
    }
  }
  @include media-max(md){
    .tabs-header{
      //flex-direction: column;
      .tab-label{
        padding: 10px 0 10px 15px;
        .title{
          font-size: 17px !important;
        }
        .icon{
          width: 40px;
          height: 40px;
        }
      }
    }
    .tabs-body{
      padding: 40px 25px;
      >div{
        .tabs-title{
          color: #5A2A00;
          font-size: 19px !important;
          line-height: 27px !important;
        }
        .tabs-content{
          .m{
            width: 60%;
          }
          p{
            font-size: 12px;
          }
        }
      }
    }
  }
  @include media-max(sm){
    padding: 35px 30px;
    .tabs-header{
      //flex-direction: column;
      .tab-label{
        .title{
          font-size: 15px !important;
        }
        .icon{
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
</style>